import React from 'react';
import './Section.css';
import './Contact.css';

export default function Contact() {
  return (
    <section id="contact" className="section">
      <div className="section-inner">
        <div className="section-header">
          <span className="section-num">06.</span>
          <h2 className="section-title">contact</h2>
          <div className="section-line" />
        </div>

        <div className="contact-wrapper">
          <div className="contact-left">
            <div className="contact-label">// get in touch</div>
            <h3 className="contact-headline">
              Let's build something<br />
              <span className="contact-accent">remarkable together.</span>
            </h3>
            <p className="contact-body">
              I'm always open to discussing new opportunities, research collaborations,
              freelance projects, or just talking shop about ML and AI.
              My inbox is always open.
            </p>

            <a
              href="mailto:krishkumar18022005@gmail.com"
              className="contact-btn"
            >
              say hello →
            </a>
          </div>

          <div className="contact-links">
            <a href="mailto:krishkumar18022005@gmail.com" className="contact-link-card">
              <div className="link-icon">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                  <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
                  <polyline points="22,6 12,13 2,6" />
                </svg>
              </div>
              <div>
                <div className="link-label">Email</div>
                <div className="link-val">krishkumar18022005@gmail.com</div>
              </div>
              <span className="link-arrow">→</span>
            </a>

            <a href="https://linkedin.com/in/krish-kumar-2951101b5/" target="_blank" rel="noreferrer" className="contact-link-card">
              <div className="link-icon">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6zM2 9h4v12H2z" />
                  <circle cx="4" cy="4" r="2" />
                </svg>
              </div>
              <div>
                <div className="link-label">LinkedIn</div>
                <div className="link-val">krish-kumar-2951101b5</div>
              </div>
              <span className="link-arrow">→</span>
            </a>

            <div className="contact-link-card no-link">
              <div className="link-icon">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                  <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.69 13.1a19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 3.6 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" />
                </svg>
              </div>
              <div>
                <div className="link-label">Phone</div>
                <div className="link-val">+91 8448125163</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
